import {useSyncExternalStore} from 'react'

import {getMobileOS, getOS, type MobileOS, OS} from '@github-ui/get-os'

const subscribe = () => () => {}
const getOSClientSnapshot = () => getOS().os
const getOSServerSnapshot = (initialOS?: OS) => initialOS ?? OS.Unknown
const getMobileOSClientSnapshot = () => getMobileOS()
const getMobileOSServerSnapshot = (initialOS?: MobileOS) => initialOS

export function useDetectedOS(initialOS?: OS): OS {
  return useSyncExternalStore(subscribe, getOSClientSnapshot, () => getOSServerSnapshot(initialOS))
}

export function useDetectedMobileOS(initialOS?: MobileOS): MobileOS | undefined {
  return useSyncExternalStore(subscribe, getMobileOSClientSnapshot, () => getMobileOSServerSnapshot(initialOS))
}
